import styled from "styles/styled_components";

const StyledTextButton = styled("button")`
  background-color: transparent;
  border: none;
  color: ${(props) => props.theme.colors.brandBlue50};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  font-size: ${(props) => props.theme.text.size.base};
  &:disabled {
    color: ${(props) => props.theme.colors.brandGray30};
  }
`;

export default StyledTextButton;
